<template>
    <section id="timeline-header">
      <div class="container">
        <div class="row">
          <div class="col-md-6 align-self-center">
            <div class="content-wrapper">
              <h2>{{ $t('timeline.title') }}</h2>
              <p>{{ $t('timeline.description') }}</p>
            </div>
          </div>
          <div class="col-md-6 align-self-center">
            <div class="video-wrapper timeline-video header-video">
              <video class="mh-100 mw-100" controls title="Merwylan Software Development" preload="metadata" allowfullscreen>
                <source src="../../assets/images/merwylan.mp4#t=0.5" type="video/mp4">
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'TimelineBanner'
  }
  </script>
  